export enum ErrorTypeEnum {
  GRAPHQL = 'GRAPHQL',
  GRAPHQL_NETWORK = 'GRAPHQL_NETWORK',
  CLIENT_NOT_INITIALIZED = 'CLIENT_NOT_INITIALIZED',

  MAPPER = 'MAPPER',
  SCHEMA_VALIDATION = 'SCHEMA_VALIDATION',

  MAGIC_LINK = 'MAGIC_LINK',
  AUTH_ERROR = 'AUTH_ERROR',

  SIGN_UP_ERROR = 'SIGN_UP_ERROR',
  CREATE_PROFILE_ERROR = 'CREATE_PROFILE_ERROR',
  UPDATE_PARENT_ACCOUNT_ERROR = 'UPDATE_PARENT_ACCOUNT_ERROR',
  CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR',
  UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR',
  UPDATE_APP_SETTINGS_ERROR = 'UPDATE_APP_SETTINGS_ERROR',
  DELETE_PARENT_ACCOUNT_ERROR = 'DELETE_PARENT_ACCOUNT_ERROR',

  CHECK_ANSWER_ERROR = 'CHECK_ANSWER_ERROR',
  CHECK_WRITING_ERROR = 'CHECK_WRITING_ERROR',

  AUDIO_MEDIA_SOURCE_ERROR = 'AUDIO_MEDIA_SOURCE_ERROR',
}
